import React, {Component} from 'react'
import {Helmet} from "react-helmet";

class BlogPage extends Component {

	componentWillMount() {
		document.body.className='blog'
	}
	render() {
		return (
			<main>
				<Helmet>
					<title>Blog | Tokariev Sviatoslav's workshop</title>
				</Helmet>
				<h1 className="heading--blog">Blog</h1>
				<div className="blog__wrapper">
					{this.props.posts.map((post,key)=>(
						<article className="blog__item" key={key}>
							<div>
								<h2 className="blog__heading">{post.heading}</h2>
								<span className="blog__subheading">Publishing date : {post.published}</span>
								<p className="blog__text">{post.text}</p>
							</div>
							<div className="blog__buttons">
								<a className="button--pink" target="_blank" rel="noopener noreferrer"
								   href={post.link}>
									Go to Article
								</a>
							</div>
						</article>
					))}
				</div>
			</main>
		)
	}

}

export default BlogPage



// WEBPACK FOOTER //
// ./src/containers/BlogPage.js